export default {
  ADDRESSEE_FETCH_START: 'ADDRESSEE_FETCH_START',
  ADDRESSEE_FETCH_SUCCESS: 'ADDRESSEE_FETCH_SUCCESS',
  ADDRESSEE_FETCH_FAILURE: 'ADDRESSEE_FETCH_FAILURE',

  ADDRESSEE_UPDATE_START: 'ADDRESSEE_UPDATE_START',
  ADDRESSEE_UPDATE_SUCCESS: 'ADDRESSEE_UPDATE_SUCCESS',
  ADDRESSEE_UPDATE_FAILURE: 'ADDRESSEE_UPDATE_FAILURE',
}
